enum Environment {
  LOCAL = 'local',
  TEST = 'test', // for running unit tests
  DEVTEST = 'devtest',
  SYSTEST = 'systest',
  EXTERNALTEST = 'externaltest',
  PREVIEW = 'preview',
  PROD = 'prod',
}

export default Environment;
